module.exports = __webpack_public_path__ + "img/bg-tweezer.06194aaa.svg";